import InputGroup from './InputGroup'

export default function RadioGroup(props) {
    return <InputGroup {...props} type="radio" />
}
